import {asyncScheduler, concat, Observable, of, switchMap} from "rxjs";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {catchError, map} from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {eventNotificationError} from "../common/EventNotificationActions";


export type ProjectContractorActionTypes = ProjectContractorNextIdActionTypes

interface ProjectContractorNextIdAction extends ReduxAction<typeof PROJECT_CONTRACTOR_NEXT_ID> {}
interface ProjectContractorNextIdSuccessAction extends ReduxAction<typeof PROJECT_CONTRACTOR_NEXT_ID_SUCCESS> {
    payload: number
}
interface ProjectContractorNextIdErrorAction extends ErrorAction<typeof PROJECT_CONTRACTOR_NEXT_ID_ERROR>{

}

export type ProjectContractorNextIdActionTypes = ProjectContractorNextIdAction
    | ProjectContractorNextIdSuccessAction
    | ProjectContractorNextIdErrorAction

export const PROJECT_CONTRACTOR_NEXT_ID = "PROJECT_CONTRACTOR_NEXT_ID";
export const PROJECT_CONTRACTOR_NEXT_ID_SUCCESS = "PROJECT_CONTRACTOR_NEXT_ID_SUCCESS";
export const PROJECT_CONTRACTOR_NEXT_ID_ERROR = "PROJECT_CONTRACTOR_NEXT_ID_ERROR";

export function projectContractorNextId(): ProjectContractorNextIdAction {
    return { type: PROJECT_CONTRACTOR_NEXT_ID };
}
export function projectContractorNextIdSuccess( payload: number ): ProjectContractorNextIdSuccessAction {
    return { type: PROJECT_CONTRACTOR_NEXT_ID_SUCCESS, payload };
}
export function projectContractorNextIdError( error: any ): ProjectContractorNextIdErrorAction {
    return { type: PROJECT_CONTRACTOR_NEXT_ID_ERROR, error };
}

export function projectContractorNextIdEpic(
    action$: Observable< ProjectContractorNextIdAction >,
    store$: StateObservable<AppState>
) {
    return action$.pipe(
        ofType( PROJECT_CONTRACTOR_NEXT_ID ),
        switchMap( _ =>  {
            const path = APP_CONFIG.baseWeb + 'projects/contractors/nextid';

            return ajax(
                APP_CONFIG.getRequestObject( path )
            ).pipe(
                map( response => projectContractorNextIdSuccess( response.response as number )),
                catchError( error => concat(
                        of( projectContractorNextIdError( error ) ),
                        of( eventNotificationError( error, store$, "project_contractor", "nextId" ) ),
                        asyncScheduler
                    )
                )
            )
        })
    )
}
